<template>
  <material-card
  :title="$t('globals.stores')"
    :color="$vuetify.theme.themes.light.secondary"
    icon="store"
  >
    <v-card-text>
      <pbas-data-table
        :exporters="$exporters"
        ref="table"
        :dataProvider="provider"
        fileNamePrefix="stores"
        identifier="storesTable"
        @error="error = $event"
        :showSelect="false"
        :canExpand="(item) => item.HasHistory"
        :showExpand="true"
        :generateProviderForExpanded="(item) => generateProvider(item)"
      ></pbas-data-table>
      <v-expansion-panels style="margin-top:10px">
        <v-expansion-panel>
          <v-expansion-panel-header class="v-card__title">
            <div class="row no-gutters">
              <div class="col">
                <v-icon class="member-expansion-panel-header-icon">
                  mail
                </v-icon>
                <span class="member-expansion-panel-header">
                  {{ $t("globals.contacts") }}
                </span>
              </div>
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <!-- <pbas-simple-table
              ref="employerDetailsStoresContactsSimple"
              :dataProvider="contactsProvider"
              fileNamePrefix="employerDetailsStoresContactsSimple"
              :identifier="
                'employerDetailsStoresContactsSimple' + selectedPlan.Id
              "
              @error="error = $event"
            ></pbas-simple-table> -->
            <contacts
              ref="storeContacts"
              entity="Store"
              :filter="'Store/EmployerId eq ' + employerId"
              :relatedHeaders="storeContactsHeaders"
              identifier="storeContacts"
              :employerId="employerId"
              @close="$emit('close')"
            ></contacts>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-card-text>
    <error-handler :error="error"></error-handler>
  </material-card>
</template>

<script>
import { mapGetters } from "vuex";
import ErrorHandler from "@/components/ErrorHandler";
import { ODataProvider } from "pbas-vue-components";
import StoresHeaders from "@/headers/Stores";
import StoresHeadersBillingImport from "@/headers/StoresBillingImport";
import StoresHistoryHeadersBillingImport from "@/headers/StoresBillingImportHistory";
import StoresHistoryHeaders from "@/headers/StoresHistory";
import StoreContactsHeaders from "@/headers/StoreContacts";
import ContactsHeaders from "@/headers/Contacts";
import { ODataHeader, ODataString } from "pbas-vue-components";
import { translate2 } from "@/trans2";
import Contacts from "@/components/Employers/Contacts.vue";
export default {
  props: ["employerId"],
  components: {
    ErrorHandler,
    Contacts,
  },
  data() {
    return {
      error: null,
      provider: undefined,
      headers: StoresHeaders,
      selectedItem: null,
      contactsProvider: undefined,
      storeContactsHeaders: [
        new ODataHeader({
          type: new ODataString("Store/Current/Name"),
          sortable: true,
          visible: false,
          searchable: true,
          version: 1,
          allowVisibilityChange: false,
        }),
        new ODataHeader({
          title: "globals.store",
          type: new ODataString("Store/Current/Translations[]/Name", {
            getString: (item) => translate2(item.Store.Current, "Name"),
          }),
          sortable: true,
          visible: true,
          searchable: true,
          version: 1,
          orderByKey: "Name",
        }),
        new ODataHeader({
          type: new ODataString("Store/Current/Translations[]/LanguageCode"),
          sortable: false,
          visible: false,
          allowVisibilityChange: false,
          searchable: false,
        }),
        new ODataHeader({
          title: "Store Id",
          type: new ODataString("Store/Id"),
          visible: false,
          allowVisibilityChange: false,
          searchable: false,
        }),
        new ODataHeader({
          title: "StoreId",
          type: new ODataString("StoreId"),
          visible: false,
          allowVisibilityChange: false,
          searchable: false,
        }),
      ],
      historyHeaders: StoresHistoryHeaders,
    };
  },
  computed: {
    ...mapGetters("common", { selectedPlan: "plan" }),
    ...mapGetters("plansMembers", ["planOptions"]),
  },
  watch: {
    selectedPlan: {
      handler() {
        this.loadPlanData();
      },
    },
  },
  mounted() {
    if (this.selectedPlan !== null && this.selectedPlan !== undefined) {
      this.loadPlanData();
    }
  },
  methods: {
    loadPlanData() {
      if (this.planOptions.HasBillingImport) {
        this.headers = StoresHeadersBillingImport;
        this.historyHeaders = StoresHistoryHeadersBillingImport;
      }

      let url = "plans/" + this.selectedPlan.Id + "/stores";
      this.provider = new ODataProvider(this.$axiosHttp, url, this.headers);
      this.provider.filter = `EmployerId eq ${this.employerId}`;

      const contactsHeaders = ContactsHeaders.concat(StoreContactsHeaders);
      url = `plans/${this.selectedPlan.Id}/contacts`;
      this.contactsProvider = new ODataProvider(
        this.$axiosHttp,
        url,
        contactsHeaders
      );
      this.contactsProvider.filter = `Store/EmployerId eq ${this.employerId}`;
    },
    reload() {
      this.$refs.table.getDataAsync();
      this.$refs.employerDetailsStoresContactsSimple &&
        this.$refs.employerDetailsStoresContactsSimple.getDataAsync();
      this.$refs.storeContacts && this.$refs.storeContacts.getDataAsync();
    },
    generateProvider(item) {
      const url =
        "plans/" + this.selectedPlan.Id + "/stores/" + item.Id + "/history";
      return new ODataProvider(this.$axiosHttp, url, this.historyHeaders);
    },
  },
};
</script>
